import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Input as MuiInput } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  container: {
    height: 'fit-content',
    backgroundColor: '#e2e2e2',
    borderRadius: 5,
    padding: '3px 15px',
    marginLeft: 5
  }
}))

const Input = (props) => {
  const classes = useStyles();
  const {
    placeholder,
    value,
    onChange,
    error,
    ...rest
  } = props;

  return (
    <div
      className={classes.container}
      style={error ? { border: '1px solid red' } : {}}
    >
      <MuiInput
        disableUnderline
        style={{ width: '100%' }}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={error}
        {...rest}
      />
    </div>
  )
}

export default Input;
